import { FlowsFIRenewalLoginAction } from "./flows-fi-renewal-login.element.action";
import { FlowsFIRenewalLoginModel, LoginOrderResponse } from "./flows-fi-renewal-login.element.model";

export const loginOrderResponse: LoginOrderResponse = {
  customerNumber: "7036759",
  agreementNumber: "4001116302",
  isValidUser: true,
  isActiveForCampaign: true,
};

export const flowsFIRenewalLoginModel: FlowsFIRenewalLoginModel = {
  customerno: "1234567",
  agreementno: "123456790",
  redirectToRenewalPageUrl: "redirect-url-page",
  loginOrderResponse: loginOrderResponse,
};

/**
 * The available viewstates of this element
 */
export const VIEWSTATES = <const>{
  loading: new FlowsFIRenewalLoginAction.Loading(),
  errorred: new FlowsFIRenewalLoginAction.Errorred(),
  focused: new FlowsFIRenewalLoginAction.Focused(),
  submit: new FlowsFIRenewalLoginAction.Submit(flowsFIRenewalLoginModel),
  completed: new FlowsFIRenewalLoginAction.Completed(loginOrderResponse),
  redirect: new FlowsFIRenewalLoginAction.Redirect(flowsFIRenewalLoginModel),
};
